import { render, staticRenderFns } from "./PrismaStatsDialog.vue?vue&type=template&id=02449cd8&scoped=true&"
import script from "./PrismaStatsDialog.vue?vue&type=script&lang=js&"
export * from "./PrismaStatsDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrismaStatsDialog.vue?vue&type=style&index=0&id=02449cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02449cd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VContainer,VRow,VTooltip})
